/**
 * @description
 * Objeto MensajeLogin
 */

export class MensajeLogin {
    
    public missatges : String;
  
    constructor() {}
  
}